/**
 * Tutorial persistence using localStorage (web-only).
 * Tracks whether the Fleet Hub onboarding tour has been shown.
 */

const STORAGE_KEY = "fleethub_onboarding_done"

export function isTutorialDone(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true"
  } catch {
    return false
  }
}

export function markTutorialDone(): void {
  try {
    localStorage.setItem(STORAGE_KEY, "true")
  } catch {
    // localStorage unavailable — tutorial will re-show on next visit
  }
}
